// SWIPER SLIDER
(function ($) {
    $('.en-swiper').each(function () {
        var swiper = new Swiper(this, $(this).data('en-swiper-options'));
    });
})(jQuery)